<template>

<div class="admin-table-block mt-4" >
        <CorporateDataTable
          :items="activosTableItems"
          :fields="allFields"
          :filter-defs="tableFilterDefs"
          :labels="tableLabels"
          :default-per-page="10"
          :page-options="[10, 20, 50, 100]"
          :narrow="false"
          :table-min-height="500"
          :table-max-height="500"
          @row-clicked="(item) => quitarActivo(item.activo)" 
        >
          <template #toolbar-actions>
            <b-button size="sm" class="table-toolbar-add-btn" @click="cierraModal(false)">
		{{ labels.regresar }}
            </b-button>
            <b-button size="sm" class="table-toolbar-add-btn" @click="adicionaActivo()">
		{{ labels.create }}
            </b-button>
          </template>
        </CorporateDataTable>
	<AdicionarActivos :modalAdActivos="showAdActivos" :numContrato="numContrato" @cierraModal="closeModal"></AdicionarActivos>
        <ModModifiElimAct :modModElimAct="showModRetMejAct" :numActivo="codActivo" :nroContrato="numContrato" @cierraModal="closeModAddRet" @refreshTblModAct="refrescaTblModAct"></ModModifiElimAct>
    </div>
</template>

<script>
import ContratoActivo from '../../services/ContratoActivo'; 
import Activos from '../../services/Activos' 
import TipoActivo from '../../services/TipoActivo'; 
import AdicionarActivos from './AdicionarActivos.vue'; 
import ModModifiElimAct from './ModModifiElimAct.vue' 
import CorporateDataTable from '../utils/CorporateDataTable.vue'; 

export default {
name : 'ModificacionActivos',
props : ['numContrato'],
components : {
        AdicionarActivos,
        ModModifiElimAct,
	CorporateDataTable,
        // InacticaItem,
},
data : () => ({
        listActivos : [],
        activos : [],
        lstTipoActivo : [],
        valAddMejora : '',
        valRetiro : '',
        fgl_adicionar: false,
        showAdActivos: false,
        quitaActivo: false,
        codActivo: null,
        showModRetMejAct : false,
        perPage: 500,
        currentPage: 1,
        fields: [
            {key: 'activo', label: 'Tipo activo', sortable: false},
            {key: 'descripcion', label: 'Descripción', sortable: false},
            {key: 'valor_inicial', label: 'Valor inicial', sortable: false},
            {key: 'valor_final', label: 'Valor final', sortable: false},
        ]
}),
computed:{
labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Modificación activos',
                    save : 'Guardar',
                    close : 'Cerrar',
                    noRow : "No hay registros",
                    activos : 'Activos',
                    tipoActivo : 'Tipo Activo',
                    proveedor : 'Proveedor',
                    valorCompra : 'Valor Inicial',
                    valorFinal : 'Valor final',
                    valorSalvamento : 'Valor salvamento',
                    valorAmortizado : 'Valor amortizado',
                    fechaCompra : 'Fecha compra',
                    valAddMejora : 'Valor adición/mejora',
                    valRetiro : 'Valor retiro',
			create : "Adicionar",
			regresar : "Cerrar",
                }            
            }else{
                return {
                    title : 'Asset modification',
                    save : 'Save',
                    close : 'Close',
                    noRow : "There are not records",
                    activos : 'Assets',
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    valorCompra : 'Purchase value',
                    valorFinal : 'Valor final',
                    valorSalvamento : 'Salvage value',
                    valorAmortizado : 'Amortized value',
                    fechaCompra : 'Purchase date',
                    valAddMejora : 'Added value/Improvement',
                    valRetiro : 'Withdrawal value'
                }                
            }
},
activosTableItems() {
	return (this.listActivos || []).map((item) => ({
	...item,
	tipo_activo_des: this.tipoActivo(item?.activo),
	descripcion: this.nameActivo(item?.activo),
	valor_inicial: this.valCompra(item?.activo),
	valor_final: this.valFinal(item?.activo),
	}));
},
allFields() {
	return [
	{ key: 'tipo_activo_des', label: this.labels.tipo_activo_des, sortable: true },
	{ key: 'descripcion', label: this.labels.descripcion, sortable: true },
	{ key: 'valor_inicial', label: this.labels.valor_inicial, sortable: false },
	{ key: 'valor_final', label: this.labels.valor_final, sortable: false },
	];
},
tableFilterDefs() {
	return [
		{ key: 'descripcion', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar descripcion...' : 'Filter Description...' }
	];
},
tableLabels() {
	return {
		noRow: this.labels.empty,
		noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
		searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
		rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
		noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
		sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
		sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
		columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
		showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
		filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
		clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters",
	};
}
},
methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        saveModActivos(){
            console.log('saveModActivos'); 
        },
        quitarActivo(activo){
            // console.log('quitarActivo',activo); 
            this.codActivo = activo 
            this.quitaActivo = true 
            this.showModRetMejAct = true 
        },
        confirmInactivate(){
            const info = {
                'activo' : this.codActivo, 
                'numContrato' : this.numContrato, 
                'idUser' : this.$store.state.userId 
            }

            Activos.quitarActivoAlContrato(info) 
            .then((res) => { 
                // console.log(res.data); 
                if (res.status == 200) { 
                    this.$toast.success(res.data.message); 
                    this.$router.push('modificarcontrato'); 
                    location.reload(); 
                }
            })
            .catch((error) => { 
                if (error.response && error.response.data) { 
                    this.$toast.error(error.response.data.message); 
                }
            })
        },
        cierraModalAdv(){
            this.quitaActivo = false 
        },
        closeModAddRet(){
            this.showModRetMejAct = false 
        },
        nameActivo(numActivo){
            let name = this.activos.find((activo) => activo.activo == numActivo) 
            if	(name == undefined) {
                return numActivo
            }
            return name?.descripcion 
        },
        tipoActivo(numActivo){
            if	(numActivo == null || numActivo == undefined) {
                return numActivo
            }
            let numTipoActivo = this.activos.find((activo) => activo.activo == numActivo) 
            if	(numTipoActivo == undefined) {
                return numActivo
            }
            let nameTipoActivo = this.lstTipoActivo.find((tipoAct) => tipoAct.tipo_activo == numTipoActivo.tipo_activo) 
            if	(nameTipoActivo == undefined) {
                return "Tipo Activo "+numActivo
            }
            return nameTipoActivo?.descripcion 
        },
        valCompra(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo) 
            if	(valor == undefined) {
                return numActivo
            }
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor?.valor_compra) 
        },
        valFinal(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo) 
            if	(valor == undefined) {
                return numActivo
            }
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor?.valor_final) 
        },
        adicionaActivo() {
            this.fgl_adicionar = true 
            this.showAdActivos = true 
        },
        closeModal(val){
            this.showAdActivos = val 
            this.showModRetMejAct = val 
        },
        refrescaTblModAct(){
            Activos.getAllActivos() 
            .then((res) => { 
                this.activos = res.data.listActivos 
            })
            .catch((err) => console.log(err)) 
        }
    },
    mounted(){
        Activos.getAllActivos() 
        .then((res) => { 
            this.activos = res.data.listActivos 
        })
        .catch((err) => console.log(err)) 

        ContratoActivo.getActivoContratoByNumContr(this.numContrato) 
        .then((res) => { 
            this.listActivos = res.data.activosContrato 
        })
        .catch((err) => console.log(err)) 


        TipoActivo.getAllTipoActivo() 
        .then((res) => { 
            // console.log(res.data.listTipoActivo); 
            this.lstTipoActivo = res.data.listTipoActivo 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>
